import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompletionModal = ({ isOpen, onClose, companyName }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="fixed inset-0 z-200 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-md bg-card rounded-xl border border-border shadow-warm-2xl p-6 md:p-8 animate-in fade-in zoom-in duration-250">
        <div className="text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-4 md:mb-6 rounded-full bg-success/10 flex items-center justify-center">
            <Icon name="CheckCircle2" size={40} color="var(--color-success)" />
          </div>

          <h2 className="text-2xl md:text-3xl font-semibold text-foreground font-heading mb-3">
            Setup Complete!
          </h2>

          <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-6">
            Congratulations! Your DraftIQ agents are now configured and ready to help {companyName || 'your business'} grow. All agents have been initialized with your company information.
          </p>

          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Users" size={16} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground text-left">Manager Agent ready for coordination</p>
            </div>
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="TrendingUp" size={16} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground text-left">Marketing Operations configured</p>
            </div>
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="CheckSquare" size={16} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground text-left">Personal Productivity initialized</p>
            </div>
            <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="BarChart3" size={16} color="var(--color-primary)" />
              </div>
              <p className="text-sm text-foreground text-left">Analytics Agent activated</p>
            </div>
          </div>

          <Button
            variant="default"
            onClick={handleGoToDashboard}
            iconName="ArrowRight"
            iconPosition="right"
            fullWidth
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CompletionModal;